import React from 'react';
import { motion } from 'framer-motion';
export function SampleMessages() {
  return <section className="py-20 bg-brand-soft-black" data-id="element-233">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
        <div className="text-center mb-16" data-id="element-235">
          <h2 className="font-heading text-3xl text-brand-white mb-4" data-id="element-236">
            Sample SMS Messages
          </h2>
          <p className="text-brand-champagne-light/70 max-w-2xl mx-auto" data-id="element-237">
            Transparency is our priority. Here are examples of the types of
            messages you might receive if you choose to opt in.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto" data-id="element-238">
          {/* Phone Mockup 1 */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="flex flex-col items-center" data-id="element-239">
            <h3 className="text-brand-gold font-medium mb-6 uppercase tracking-wider text-sm" data-id="element-240">
              Appointment Reminder
            </h3>
            <div className="w-full max-w-[300px] bg-brand-black border-[6px] border-brand-charcoal rounded-[2.5rem] p-4 shadow-xl relative h-[400px] flex flex-col" data-id="element-241">
              {/* Phone Notch */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-brand-charcoal rounded-b-xl" data-id="element-242"></div>

              <div className="mt-8 flex-1 flex flex-col justify-end space-y-4 pb-4" data-id="element-243">
                <div className="bg-brand-charcoal/80 text-brand-white p-4 rounded-2xl rounded-bl-sm text-sm border border-brand-gold/10 self-start max-w-[85%] shadow-sm" data-id="element-244">
                  <span className="font-semibold text-brand-gold block mb-1" data-id="element-245">
                    Deluxe MedSpa Beauty:
                  </span>
                  Hi Sofia, this is a reminder for your consultation on Friday
                  at 3:00 PM. Reply STOP to opt out or HELP for help.
                </div>
              </div>
            </div>
          </motion.div>

          {/* Phone Mockup 2 */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-col items-center" data-id="element-246">
            <h3 className="text-brand-gold font-medium mb-6 uppercase tracking-wider text-sm" data-id="element-247">
              Promotional Offer
            </h3>
            <div className="w-full max-w-[300px] bg-brand-black border-[6px] border-brand-charcoal rounded-[2.5rem] p-4 shadow-xl relative h-[400px] flex flex-col" data-id="element-248">
              {/* Phone Notch */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-brand-charcoal rounded-b-xl" data-id="element-249"></div>

              <div className="mt-8 flex-1 flex flex-col justify-end space-y-4 pb-4" data-id="element-250">
                <div className="bg-brand-charcoal/80 text-brand-white p-4 rounded-2xl rounded-bl-sm text-sm border border-brand-gold/10 self-start max-w-[85%] shadow-sm" data-id="element-251">
                  <span className="font-semibold text-brand-gold block mb-1" data-id="element-252">
                    Deluxe MedSpa Beauty:
                  </span>
                  Enjoy our latest treatment specials this month. Message
                  frequency varies. Msg & data rates may apply. Reply STOP to
                  opt out or HELP for help.
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}